module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921084151_T.ef694a4a.jpg";